<template>
    <v-row justify="center" class="border-radius-3">
        <v-dialog 
            v-model="dialog"
            persistent
            :width="$vuetify.breakpoint.xs ? '90%' : '70%'"
            content-class="border-radius-2 pt-0"
            overlay-color="#7764CA"
            overlay-opacity="1">
            <div class="onboarding-logo-wrapper">
                <v-img 
                    :src="logo"
                    width="100"
                    class="mx-auto">
                </v-img>
            </div>
            <v-row class="progress-bar-wrapper ma-0">
                <v-col cols="12" class="position-relative">
                    <v-progress-linear
                    background-color="#514585"
                    color="#C4BBE7"
                    value="100"
                    height="18"
                    class="pointer-events-none border-progress-bar"
                    rounded
                    >
                    <strong>{{ $t('initialTour.completed') }}</strong>
                </v-progress-linear>
                    <v-img
                    :src="require('@/assets/img/icons/check-stroke.png')"
                    height="48"
                    width="48"
                    class="check-icon"
                    ></v-img>
                </v-col>
            </v-row>

            <v-card class="custom-card border-radius-2 pa-4 pa-sm-8">
                <v-row>
                    <v-col cols="12">
                        <v-card-title class="pt-0 d-flex justify-center px-10 mb-sm-6 position-relative">
                            <v-img
                                :src="require(`@/assets/img/icons/icon-voice-assistant.svg`)"
                                max-height="40px"
                                max-width="40px"
                                :min-width="$vuetify.breakpoint.xs ? '32' : '40'"
                                :min-height="$vuetify.breakpoint.xs ? '32' : '40'"
                                contain
                                class="main-sound-img-abs cursor-pointer"
                                @click="read"
                            ></v-img>
                            <span class="titles text-h4 font-weight-medium py-3 d-flex justify-center">
                                {{ $t('initialTour.finish_msg') }}
                            </span>
                        </v-card-title>

                        <v-card-subtitle class="px-5">
                            <p class="titles font-weight-regular text-h5">
                                {{ $t('initialTour.pre_modal_msg.msg_1') }}
                                <span>{{ $t('initialTour.pre_modal_msg.msg_2') }}</span>
                            </p>
                        </v-card-subtitle>
                    </v-col>
                </v-row>

                <v-card-actions class="d-flex justify-center">
                    <v-btn 
                        data-cy="continue-button-pre-poll"
                        class="bg-gradient-primary px-15 border-radius-1 text-transform-none font-weight-bolder"
                        large
                        dark
                        @click="nextPass">{{
                        $t('initialTour.continue')
                    }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>
<script>
import { mapState, mapActions } from 'vuex'

import Avatar from './AvatarCore/Avatar.vue'
import initialReaderValidation from "../../mixins/InitialReaderValidation";

export default {
    data() {
        return {
            logo: require('@/assets/img/brand/logo.svg'),
        }
    },
    props: {
        dialog: { type: Boolean, default: false },
    },
    components: {
        Avatar,
    },
    computed: {
        ...mapState({
            user: (state) => state.userData.user,
            stUserAvatar: (state) => state.userData.avatarSelected,
            survey: (state) => state.userData.survey,
            course: (state) => state.userData.user.course,
            diagnosticData: (state) => state.dashboard.testDiagnostic,
        }),
        greetWelcomeMessage() {
            // eslint-disable-next-line no-nested-ternary
            return `${this.$t('initialTour.excellent')} ${this.$utils.upperFirstLetter(this.user.firstname.split(' ')[0])}!`
        },
    },
    methods: {
        ...mapActions('dashboard', [
            'showInitialPoll',
            'mountDiagnostic',
            'showFinishPreferencesModal',
            'showDiagnosticTutorialModal',
            'showFinishOnBoardingModal',
            'showFinishSurveyModal'
        ]),
        nextPass() {
            console.log('nextPass')
            this.showFinishPreferencesModal()
            const isPregrade = ['G0'].some(g => this.grade === g);
            // if (!isPregrade && this.survey) {
            //     this.showInitialPoll();
            //     return
            // }
            if (!isPregrade && this.diagnosticData.length > 0) {
                this.mountDiagnostic();
                return
            }

            this.showFinishOnBoardingModal();
        },
        read(){
            this.play('pre_diagnostic')
        },
        play(text) {
            if (this.audio && !this.audio.paused) {
                this.audio.pause()
            }
            const audio = new Audio(`${process.env.VUE_APP_VOICE_SAMPLE_URL}onboarding/${text}.mp3`);
            audio.play()
                .then(() => {
                    this.audio = audio;
                })
                .catch(() => {
                    this.audio = null;
                });
        },
    },
    mixins: [initialReaderValidation]
}
</script>
<style>
.avatar-stars {
    background: url(../../assets/img/effects/avatar-stars.svg) round;
}
.titles{
    word-break: keep-all;
}
.main-sound-img-abs {
    position: absolute;
    top: 16px;
    left: 0;
}
</style>
